import React from 'react';
import TextField from '@mui/material/TextField';
import { useTranslation } from 'react-i18next';

interface RegistrationNumberInputProps {
  value?: string | null;
  onChange: (value: string | null) => void;
  disabled: boolean;
}

export default function RegistrationNumberInput({
  value,
  onChange,
  disabled,
}: RegistrationNumberInputProps) {
  const { t } = useTranslation();

  return (
    <TextField
      label={t('formInputs.registrationNumberInputLabel')}
      variant='outlined'
      fullWidth
      value={value ?? ''}
      onChange={(e) => onChange(e.target.value ? e.target.value : null)}
      disabled={disabled}
    />
  );
}
